<template>
  <el-dialog :visible.sync="currentValue" v-if="currentValue" width="1477px" top="auto" custom-class="task-dialog" :show-close="false" :before-close="dialogBeforeClose">
    <template slot="title">
      <div class="task-head">
        <div class="task-head-left">
          <div class="task-head-in" :class="{'only-one': index === breadcrumb.length - 1}" v-for="(item,index) in breadcrumb" :key="item.id">
            <span class="task-head-space" v-if="index > 0">/</span>
            <toolTip v-if="item.type" class="task-head-txt" show title="进入项目主页" maxWidth="220px" @click.native="openedTask(item,index)">
              <span>{{item.task_name}}</span>
            </toolTip>
            <toolTip v-else class="task-head-txt" :title="item.task_name" maxWidth="220px" @click.native="openedTask(item,index)">
              <span>{{item.task_name}}</span>
            </toolTip>
          </div>
        </div>
        <div class="task-head-right">
          <div class="archive-btn-wrap" v-if="editData.archive_permission && editData.edit_permission && !editData.isDisabledProject" @click="archivedTask">
            <i class="icon iconfont iconicon_move"></i>
            <span>归档任务</span>
          </div>
          <el-tooltip v-if="editData.task_level < 2 && !editData.isDisabledProject" class="item follow-btn" effect="dark" :content="editData.is_attention ? '取消关注' : '关注任务'" placement="bottom" @click.native="handleCommand(editData.is_attention ? 'cancel_attention' : 'add_attention')">
            <FollowTask :show="true" :is_attention="editData.is_attention"></FollowTask>
          </el-tooltip>
          <div v-if="editData.edit_permission && !editData.isDisabledProject">
            <SelectFile v-if="getFileCount > 1" @change="uploadSuccess" :editData="editData"></SelectFile>
            <el-tooltip v-else class="item" effect="dark" content="添加任务附件" placement="bottom">
              <SelectFile @change="uploadSuccess" :editData="editData"></SelectFile>
            </el-tooltip>
          </div>
          <el-tooltip v-if="editData.create_subtask_permission && editData.edit_permission && editData.task_level < 3 && !editData.isDisabledProject" class="item" effect="dark" content="添加子任务" placement="bottom" @click.native="addChild">
            <i class="icon iconfont iconicon_subtasks2"></i>
          </el-tooltip>
          <el-tooltip v-if="editData.association_permission && editData.edit_permission && editData.task_stage !== '已完成' && !editData.isDisabledProject" class="item" effect="dark" content="添加关联任务" placement="bottom" @click.stop.native="addConnect">
            <i class="icon iconfont iconicon_associated_tasks"></i>
          </el-tooltip>
          <el-dropdown @command="handleCommand" size="small" trigger="click" class="task-box-more" placement="bottom" :show-timeout="100">
            <i class="icon iconfont iconicon_more_task1"></i>
            <el-dropdown-menu slot="dropdown" class="task-box-more-dropdown">
              <el-dropdown-item command="del" class="task-box-more-del" v-if="editData.delete_permission && !editData.isDisabledProject">
                <i class="icon iconfont iconicon_recycle_bin"></i>
                移至回收站
              </el-dropdown-item>
              <!-- <el-dropdown-item command="archive" v-if="editData.archive_permission"><i class="icon iconfont iconicon_data_nor"></i>归档</el-dropdown-item> -->
              <el-dropdown-item class="no-hover" :class="{'not-border':!editData.delete_permission || editData.isDisabledProject}" disabled>
                <div class="task-war">
                  <p><span class="dot">任务编号：</span>{{editData.task_sn}}</p>
                  <p><span class="dot">创建人：</span>{{editData.created_user ? editData.created_user.realname : ''}}</p>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-tooltip class="item" effect="dark" content="关闭" placement="bottom">
            <i class="icon iconfont iconicon_close1" @click="currentValue = false"></i>
          </el-tooltip>
        </div>
      </div>
    </template>
    <div class="task-panel" v-loading="viewLoading">
    <!-- 项目冻结、归档 -->
      <div class="task-head-stage is-deleted" v-if="isdeletedTask">
        <p>
          {{editData.isDisabledProject ? '该任务已在回收站中，不可编辑' : '该任务已在回收站中，不可编辑，您可以点击'}}
          <span class="recovery" v-if="!editData.isDisabledProject" @click="handleRecover">恢复任务</span>
        </p>
      </div>
      <div class="task-head-stage is-deleted" v-if="editData.task_stage === '已归档' && !isdeletedTask">
        <p>
          {{editData.isDisabledProject ? '该任务已归档，不可编辑' : '该任务已归档，除评论功能外不可编辑'}}
          <span v-if="editData.activate_archived_tasks_permission && !editData.isDisabledProject ">，您可以点击</span>
          <span class="recovery" @click="archivedTask(taskId, 'recover')" v-if="editData.activate_archived_tasks_permission && !editData.isDisabledProject ">恢复未归档</span>
        </p>
      </div>

      <div class="task-panel-wrap">
        <div class="task-panel-left" v-if="!viewLoading">
          <TaskTitle
            :editData="editData"
            :taskName.sync="form.task_name"
            :taskStatus.sync="form.task_stage"
            :isCompete="editData.before_archiving_is_completed"
            @finishTask="finishTask"
            @change="saveData(true)"
          ></TaskTitle>
          <FormTemp title="优先级" icon="iconicon_priority">
            <LevelStatus :readonly="!editData.edit_permission || editData.isDisabledProject" v-model="form.sort_rule_id" @change="saveData" :sortList="sortList" />
          </FormTemp>
          <FormTemp title="执行人" icon="iconicon_executor">
            <Executor :readonly="!editData.edit_permission || editData.isDisabledProject" v-model="outerTaskExecutor_user" :defaultValue="editData.executor_user" :projectId="editData.project_id" @change="saveData(true)" :parentId="parentId" @changeRunMan="changeRunMan" :user_in_parent_tasks_permission="editData.user_in_parent_tasks_permission"></Executor>
          </FormTemp>
          <FormTemp title="参与人" icon="iconicon_participant">
            <Participant
              v-if="!loading"
              :readonly="!editData.edit_permission || editData.isDisabledProject"
              ref="ParticipantTemp"
              v-model="outerTask_members"
              :defaultValue="editData.task_members_user"
              :projectId="editData.project_id"
              :parentId="parentId"
              :taskId="taskId"
              @change="saveData(true)"
              :lockUid="lockUid"
              isTags
            ></Participant>
          </FormTemp>
          <FormTemp title="完成日期" icon="iconicon_time1">
            <RangeTime :readonly="!editData.edit_permission || editData.isDisabledProject" :taskStatus="editData.task_stage" v-model="timeRange" @change="saveData(true)" />
          </FormTemp>
          <FormTemp v-for="(item) in (editData.template ? editData.template.template_standard_components : [])" :key="item.id" :readonly="!editData.edit_permission || editData.isDisabledProject" :value="getTemplateDefaultValue(item.id)" :title="item.component_name_in_template" :icon="keyIcon[item.component_code] || 'iconicon_custom_field'">
            <component
              :readonly="!editData.edit_permission || editData.isDisabledProject"
              @change="saveData"
              :item="item"
              :is="item.component_code"
              v-model="form[`${getketText(item)}`]"
              :projectId="editData.project_id"
              :config="getTempConfig(item)"
              :memberList="memberList"
              :defaultValue="getTemplateDefaultValue(item.id)"
              :getketText="getketText"
              :isTaskDetail="true"
              isTags
            ></component>
          </FormTemp>
        </div>
        <div class="task-panel-right" ref="task-preview" v-if="!viewLoading">
          <ChildTask
            ref="chaildtask"
            :create_subtask_permission="editData.create_subtask_permission && !editData.isDisabledProject"
            v-if="editData.project_id && editData.task_level < 3"
            @openedTask="opendAddTask"
            :taskId="taskId"
            :projectId="editData.project_id"
            :taskListId="editData.task_list_id"
            :templateId="template_id"
            :parentExecutorUid="form.executor"
            :isDisabledProject="editData.isDisabledProject"
            :editPermission="editData.edit_permission"
            :sortList="sortList"
            @change="childTaskChange"
            @finish="canRealMessage"
            @handleArchive="archivedTask"
          ></ChildTask>

          <ConnectTask
            ref="connect"
            v-if="editData.project_id"
            :project_id="editData.project_id"
            :task_id="editData.id"
            :primission="editData.association_permission && editData.edit_permission && !editData.isDisabledProject"
            :addPrimission="true"
            :association_dependency="editData.association_dependency || {}"
            :isDisabledProject="editData.isDisabledProject"
            @change="getTaskDetail"
            @openedTask="opendNewTask"
            @handleArchive="archivedTask"
          ></ConnectTask>

          <Comment
            ref="comment"
            :isdeleted="isdeleted"
            :taskId="editData.id"
            :project_id="editData.project_id"
            :disabled="editData.isDisabledProject"
            @toScorllTop="toScorllTop"
          ></Comment>
        </div>
      </div>

    </div>
  </el-dialog>
</template>

<script>
import api from '@/services/api/customKey/customKey';
import apiTask from '@/services/api/task/task';
import apiRecycle from '@/services/api/recycle';
import followApi from '@/services/api/follow/follow'
import apiMsg from '@/services/api/project/project';
import apiRecycleBin from '@/services/api/recycle';
import bus from '@/bus'
import TaskTitle from './taskTitle'
import FormTemp from './formTemp'
import ChildTask from './childTask'
import ConnectTask from './connectTask'
import SelectFile from './selectFile'
import Comment from './comment'
import { mapActions } from 'vuex'

export default {
  props: {
    value: Boolean,
    opendTaskId: {
      type: [Number, String]
    },
    task_list_id: {
      type: [Number, String]
    },
    // 是否为已删除的任务
    isdeleted: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TaskTitle,
    FormTemp,
    ChildTask,
    ConnectTask,
    Comment,
    SelectFile
  },
  data() {
    return {
      form: {
        task_name: '',
        sort_rule_id: '',
        task_stage: '',
        executor: '',
        start_time: '',
        end_time: '',
        task_members: []
      },
      outerTaskExecutor_user: {},
      outerTask_members: [],
      breadcrumb: [],
      viewLoading: true,
      isNeedChange: false, // 是否需要通知该条任务更新
      editData: {},
      template_id: '',
      tableTemplate: [],
      sortList: [],
      memberList: [],
      timeRange: [],
      taskId: '',
      loading: false,
      isNeedReset: false,
      isdeletedTask: false, // 是否为已删除的任务
      isWriting: false,
      isCheckClosed: false
    }
  },
  watch: {
    timeRange() {
      if (this.timeRange && this.timeRange.length > 0) {
        this.form.start_time = this.timeRange[0]
        this.form.end_time = this.timeRange[1]
      } else {
        this.form.start_time = ''
        this.form.end_time = ''
      }
    },
    value(val) {
      if (val) {
        this.taskId = this.opendTaskId
        this.isdeletedTask = this.isdeleted
      }
    },
    outerTask_members() {
      this.form.task_members = this.outerTask_members && this.outerTask_members.length > 0 ? this.outerTask_members.map(res => res.uid || res.user.uid) : []
    },
    outerTaskExecutor_user() {
      this.form.executor = this.outerTaskExecutor_user ? this.outerTaskExecutor_user.uid : {}
    },
  },
  computed: {
    currentValue: {
      get: function () {
        if (this.value && this.taskId) {
          this.getFromRules()
        }
        return this.value || undefined;
      },
      set: function (newValue) {
        if (!newValue) {
          this.closed()
        }
        this.$emit('input', newValue || null)
      }
    },
    parentId() {
      let item = this.breadcrumb[this.breadcrumb.length - 2]
      return item && !item.type ? item.id : ''
    },
    lockUid() {
      if (this.editData.task_members_user) {
        return this.editData.task_members_user.map(res => {
          if (res.is_executor || res.is_child_task_executor) {
            return res.uid
          }
        }).filter(res => res)
      } else {
        return this.form.executor ? [this.form.executor] : []
      }
    },
    getFileCount() {
      return this.editData.template.template_standard_components.reduce((pre, item) => {
        if (item.component_code === 'TaskComponent.Attachment.Attachment') {
          return pre + 1
        } else {
          return pre
        }
      }, 0)
    }
  },
  methods: {
    ...mapActions('project/project', ['getNewProjectMember']),
    ...mapActions('task/task', ['updateStatus']),
    async getFromRules() {
      this.loading = true
      this.init()
      await this.getTaskDetail() // 获取任务详情
      await this.getNewProjectMember({ project_id: this.editData.project_id, working_status: '在职' })  // 获取项目成员
      await this.getProjectTemplate() // 获取自定义字段
      await this.getTaskSortList() // 获取优先级
      this.loading = false
    },
    canRealMessage() {
      this.realMessage()
    },
    async realMessage() {
      await apiMsg.setNewTaskAndChildrenTaskMessageRead({ one_click_read: 1, task_id: this.taskId })
      bus.$emit('fetchProjectUnreadMessage') // 刷新角标
    },
    opendAddTask(item) {
      if(!this.breadcrumb[0] || !this.breadcrumb[0].type) {
        this.breadcrumb.unshift({
          task_name: item.project.title,
          id: item.project.project_id,
          type: 'project'
        })
      }
      this.breadcrumb.push({
        task_name: item.task_name,
        id: item.id
      })
      this.taskId = item.id
    },
    openedTask(item, index) {
      if(item.type) {
        this.$router.push(`/task?projectId=${item.id}&isTabShow=true`)
        this.currentValue = false
        return
      }
      if (item.id === this.taskId) return
      if (index > -1) {
        this.breadcrumb.splice(index + 1)
      }
      this.taskId = item.id
    },
    opendNewTask(item) {
      this.taskId = item.id
      this.breadcrumb = []
    },
    init() {
      this.editData = {}
      this.timeRange = []
      this.tableTemplate = []
      this.isCheckClosed = false
      this.isWriting = false
      this.form = {
        task_name: '',
        sort_rule_id: '',
        task_stage: '',
        executor: '',
        start_time: '',
        end_time: '',
        task_members: []
      }
      if(this.taskId === this.opendTaskId) {
        this.isNeedChange = false
        this.isNeedReset = false
      }
    },
    changeRunMan(item) { // 添加执行人时自动把执行人添加到参与人中
      if(!item) return
      if (!this.outerTask_members.find(res => res.uid === item.uid)) {
        this.outerTask_members.push(item)
      }
    },
    tileData(dataList) {
      let arr = [];
      dataList.forEach(item => {
        arr = [...arr, ...item.member];
      });
      return arr;
    },
    getTaskSortList() {
      return apiTask.getTaskSortList({ sort_rule_type_id: 1 }).then(res => {
        this.sortList = res.reverse()
      })
    },
    getProjectTemplate() {
      let parmas = {
        number: 999,
        page: 1,
        project_id: this.editData.project_id
      }
      return api.getprojectTemplate(parmas).then(res => {
        this.template_id = res.data[0].id
        this.tableTemplate = JSON.parse(JSON.stringify(res.data.length > 0 ? res.data[0].template_standard_components : []))
      }).catch(err => {
        console.log(err)
      })
    },
    getTaskDetail() {
      this.viewLoading = true
      const _api = this.isdeletedTask ? apiRecycleBin.getDeletedTaskDetail : apiTask.getTaskDetail
      return _api({ task_id: this.taskId}).then(res => {
        this.form.task_name = res.task_name
        this.form.sort_rule_id = res.sort_rule.sort
        this.form.task_stage = res.task_stage
        this.outerTask_members = res.task_members_user
        this.outerTaskExecutor_user = res.executor_user || {}
        if (res.start_time && res.end_time) {
          this.form.start_time = res.start_time
          this.form.end_time = res.end_time
          this.timeRange = [res.start_time, res.end_time]
        }
        if (this.breadcrumb.length === 0 && res.parent_tasks.length > 0) {
          this.breadcrumb = JSON.parse(JSON.stringify(res.parent_tasks))
          this.opendAddTask(res)
        }else if(this.breadcrumb.length === 0){
          this.opendAddTask(res)
        }
        this.editData = JSON.parse(JSON.stringify(res))

        // 判断是否已归档，已归档则无编辑权限
        this.editData.edit_permission = this.editData.edit_permission ? this.editData.task_stage === '已归档' ? false : this.editData.edit_permission : this.editData.edit_permission
        this.editData.isDisabledProject = this.editData.project.status === -2 || this.editData.project.is_archived === 1
        console.log('------------asd------', this.editData.isDisabledProject)
        // 处理关联任务，加上是否已完成态
        if (this.editData.association_dependency && this.editData.association_dependency.post_tasks) {
          this.handleAddIsComplate(this.editData.association_dependency.post_tasks)
        }
        if (this.editData.association_dependency && this.editData.association_dependency.pre_tasks) {
          this.handleAddIsComplate(this.editData.association_dependency.pre_tasks)
        }

        this.viewLoading = false
      })
    },
    connectTaskListFn() {
      this.handleAddIsComplate(this.editData.association_dependency.pre_tasks)
      this.handleAddIsComplate(this.editData.association_dependency.post_tasks)
    },
    handleAddIsComplate(data) {
      if (!data.tasks || !data.tasks.length) return
      data.tasks.forEach(item => {
        const _item = item.associated_task
        item.isComplate = _item.task_stage === '已归档' ? _item.before_archiving_is_completed : _item.task_stage === '已完成'
      })
    },
    finishTask() {
      this.taskUpdateStatus(this.form.task_stage)
    },
    taskUpdateStatus(task_stage) {
      return apiTask.updateTaskStage({ task_id: this.editData.id, task_stage }).then(res => {
        this.getTaskDetail()
      }).catch(err => {
        if (err.code === 403) {
          this.getFromRules()
        }
      })
    },
    async saveData(fl) {
      this.isWriting = true
      let standard_components_values = []
      for (let key in this.form) {
        if (key.indexOf('TaskComponent') > -1 && (this.form[key] || this.form[key] === null || this.form[key] === 0 || this.form[key] === '')) {
          let arr = key.split('-')
          standard_components_values.push({
            component_id_in_template: arr.find(res => res.indexOf('id') > -1).replace('id', ''),
            component_value: this.form[key] === null || this.form[key].length === 0 ? '' : this.form[key],
          })
        }
      }
      let params = {
        task_id: this.taskId || '',
        sort: this.editData.sort || 0,
        task_name: this.form.task_name || '',
        task_stage: this.form.task_stage || '',
        project_id: this.editData.project_id || 0,
        task_list_id: this.editData.task_list_id || 0,
        template_id: this.editData.template.id || 0,
        sort_rule_id: this.form.sort_rule_id || '',
        executor: this.form.executor || 0,
        task_members: this.form.task_members,
        standard_components_values
      }

      if (this.form.start_time) {
        params.start_time = this.form.start_time
        params.end_time = this.form.end_time
      } else {
        params.start_time = ''
        params.end_time = ''
      }
      let result = await apiTask.updateTaskView(params)
      if (this.breadcrumb.length) {
        this.breadcrumb[this.breadcrumb.length - 1].task_name = result.task_name
      }
      this.isNeedChange = true
      if (fl === true) {
        this.editData = {}
        await this.getTaskDetail()
      }
      this.isWriting = false
      if(this.isCheckClosed) {
        this.currentValue = false
        // this.closed()
      }
    },
    dialogBeforeClose(done) {
      if(!this.isWriting) {
        done()
      }
      this.isCheckClosed = true
    },
    // 恢复任务
    handleRecover() {
      this.$wfAlert('warning', '确认恢复内容吗？', '恢复内容后，内容将恢复至原来位置。', '恢复内容').then(async () => {
        const res = await apiRecycle.postRestoreTasks({ taskIds: [this.taskId] })
        if (res) {
          this.isNeedChange = true
          this.isNeedReset = true
          this.$message({
            message: '恢复任务成功',
            type: 'success'
          })
          this.isdeletedTask = false
          this.$nextTick(() => {
            this.getTaskDetail()
          })
          bus.$emit('refreshRecycleList')
        }
      }).catch(() => {
        console.log('执行异常')
        next(false)
      })

    },
    // 删除任务
    async deletedTask($event) {
      this.$wfAlert('warning', '确认需要删除该任务?', '', '确定').then(async () => {
        const res = await apiTask.delTask({ task_id: this.taskId })
        if (res) {
          this.$message({
            message: '删除任务成功',
            type: 'success'
          })
          this.isNeedChange = true
          this.isNeedReset = true
          if (this.breadcrumb.length > 1) {
            this.openedTask(this.breadcrumb[this.breadcrumb.length - 2], this.breadcrumb.length - 2)
          } else {
            this.currentValue = false
          }
        }
      }).catch(() => {
        console.log('执行异常')
        next(false)
      })
    },
    // 归档
    async archivedTask(id, handleType) {
      let _tit, _msg, _btn, _alertText, param
      if (typeof id === 'number' && handleType === 'recover') {
        // 恢复未归档任务
        _tit = '确认恢复未归档任务吗?'
        _msg = '恢复未归档后，任务将恢复至原来位置。'
        _btn = '恢复未归档'
        _alertText = '已成功恢复未归档任务'
        param = {
          task_id: id,
          task_stage: '进行中'
        }
      } else {
        // 归档任务
        _tit = '确认需要归档该任务?'
        _msg = ''
        _btn = '确定'
        _alertText = '已成功归档任务'
        param = {
          task_id: typeof id === 'number' ? id : this.taskId,
          task_stage: '已归档'
        }
      }
      this.$wfAlert('warning', _tit, _msg, _btn).then(async () => {
        this.updateStatus(param).then(res => {
          this.isNeedChange = true
          this.isNeedReset = true
          this.$message({
            message: _alertText,
            type: 'success'
          })
          // if (this.breadcrumb.length > 1) {
          //   this.openedTask(this.breadcrumb[this.breadcrumb.length - 2], this.breadcrumb.length - 2)
          // } else {
          //   this.currentValue = false
          // }
          this.$nextTick(() => {
            this.getTaskDetail()
          })
        }).catch(err => {
          console.log(err)
        })
      }).catch(() => {
        console.log('执行异常')
        next(false)
      })
    },
    subscriptionTask(action) {
      followApi.subscriptionTask({ task_id: this.taskId }).then(res => {
        this.getTaskDetail()
      })
    },
    unsubscribeTask(action) {
      followApi.unsubscribeTask({ task_id: this.taskId }).then(res => {
        this.getTaskDetail()
      })
    },
    handleCommand(type) {
      if (type === 'del') {
        this.deletedTask()
      } else if (type === 'archive') {
        this.archivedTask()
      } else if (type === 'add_attention') {
        this.subscriptionTask()
      } else if (type === 'cancel_attention') {
        this.unsubscribeTask()
      }
      this.isNeedChange = true
    },
    getTempConfig(item) {
      let params = {
        ...item.component_config_in_template,
        component_desc_in_template: item.component_desc_in_template,
        component_name_in_template: item.component_name_in_template,
        component_code: item.component_code
      }
      return params
    },
    getTemplateDefaultValue(id) {
      let item = this.editData.template.template_standard_components
      let component = item.find(res => res.id === id) || ''
      return component ? component.component_values : ''
    },
    getketText(item, filter) {
      let strKey = item.component_code.split('.').join('-')
      let text = strKey + '-id' + item.id
      if (filter && !item.component_config_in_template.is_require) {
        return ''
      }
      return text
    },
    closed() {
      this.isNeedChange ? bus.$emit('updateTask', {project_id: this.editData.project_id, task_list_id: this.editData.task_list_id, task_id: this.editData.id, isNeedReset: this.isNeedReset}) : ''
      this.breadcrumb = []
      bus.$emit('taskClose')
    },
    addChild() {
      this.$refs.chaildtask.addNewTask()
    },
    addConnect() {
      this.$refs.connect.opendPopover()
    },
    uploadSuccess(res) {
      console.log(this.form, res)
      if (!this.form[res.form]) {
        this.form[res.form] = []
        this.form[res.form].push(res.data.attachment_sign)
      } else {
        this.form[res.form].push(res.data.attachment_sign)
      }
      this.saveData(true)
    },
    toScorllTop() {
      console.log(this.$refs.comment)
      let doms = this.$refs['task-preview']
      let ele = this.$refs.comment.$el
      doms.scrollTop = ele.offsetTop - 200
    },
    childTaskChange() {
      this.isNeedChange = true
      this.getTaskDetail()
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.task-war {
  padding-top: 10px;
  p {
    display: flex;
    align-items: center;
  }
  .dot {
    display: block;
  }
}
.task-dialog {
  max-width: 1420px;
  min-width: 1000px;
  .more {
    margin-left: 16px;
    width: 28px;
    height: 28px;
    border-radius: 2px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 1px;
    box-sizing: border-box;
    margin-top: 10px !important;
    &:hover {
      @include bgColorOpacity(.06);
    }
    &:active {
      @include bgColorOpacity(.12);
    }
  }
  .task-head-is-deleted {
    position: relative;
    p {
      text-align: center;
    }
    .iconicon_close1 {
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
      font-size: 15px;
      padding: 4px;
      border-radius: 4px;
      margin-left: 16px;
      &:hover {
        background-color: rgba(32, 32, 32, 0.08);
        color: #2682ff;
      }
    }
  }
  .task-head {
    display: flex;
    align-items: center;
    height: 50px;
    padding: 0 32px;
    justify-content: space-between;
    .task-head-left {
      display: flex;
      font-size: 16px;
      align-items: center;
      justify-content: flex-start;
      width: 0;
      flex: 1;
      line-height: 24px;
      .task-head-in {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        @include fontColorOpacity(.6);
        &:hover .task-head-txt {
          color: #202020;
          cursor: pointer;
        }
        &:last-child {
          &:hover .task-head-txt {
          cursor: auto;
          @include fontColorOpacity(1);
        }
        }
      }
      .task-head-space {
        flex-shrink: 0;
        padding: 0 5px;
      }
      .only-one {
        @include fontColorOpacity(1);
        // &:hover .task-head-txt {
        //   @include fontColorOpacity(1);
        // }
      }
    }
    .task-head-right {
      display: flex;
      align-items: center;
      i {
        color: rgba(32, 32, 32, 0.8) !important;
        &.iconicon_following {
          color: #FFBE23 !important;
        }
      }
      .archive-btn-wrap {
        width: 102px;
        height: 32px;
        border-radius: 4px;
        border: 1px solid rgba(32, 32, 32, .16);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        line-height: 32px;
        // margin-right: 17px;
        cursor: pointer;
        &:hover {
          @include bgColorOpacity(.06);
        }
        &:active {
          @include bgColorOpacity(.12);
        }
        i {
          font-size: 14px;
          margin-right: 8px;
        }
      }
      .item,
      .task-box-more,
      .select-file {
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        @include fontColorOpacity(.8);
        cursor: pointer;
        border-radius: 4px;
        margin-left: 14px;
        &:hover {
          @include bgColorOpacity(.06);
        }
        &:active {
          @include bgColorOpacity(.12);
        }
        i {
          @include fontColorOpacity(.8);
          &.iconicon_guanzhu {
            color: #FFBE23;
          }
        }
      }
      .select-file {
        // margin: 0 16px 0 16px;
        i {
          &:hover {
            background: none;
            @include fontColorOpacity(.8);
          }
          &:active {
            background: none;
            @include fontColorOpacity(.8);
          }
        }
      }
      // .task-box-more {
      //   margin: 0 16px;
      // }
      // .iconicon_associated_tasks {
      //   margin-left: 16px;
      // }
    }
  }
  .task-panel {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .task-head-stage {
      width: 100%;
      height: 48px;
      @include bgColorOpacity(.08);
      p {
        text-align: center;
        line-height: 48px;
        @include fontColorOpacity(.8);
        .recovery {
          cursor: pointer;
          margin-left: 8px;
          color: #2682FF;
          text-decoration: underline;
        }
      }
    }
    .task-panel-wrap {
      display: flex;
      flex: 1;
      height: 0;
    }
    .task-panel-left {
      overflow-x: hidden;
      padding: 24px 32px;
      border-right: 1px solid rgba(231, 232, 237, 0.6);
      flex: 1;
      box-sizing: border-box;
    }
    .task-panel-right {
      overflow-x: hidden;
      padding: 0 32px;
      box-sizing: border-box;
      flex-shrink: 0;
      width: 654px;
      box-sizing: border-box;
    }
  }
  .el-dialog__body {
    padding: 0;
    height: calc(100% - 50px);
    color: initial;
  }
  .el-dialog__header {
    padding: 0;
    border-bottom: 1px solid #ecedf1;
  }
  height: 80%;
  transform: translate(0, -50%);
  top: 50%;
}
.connect-dialog,
.task-dialog {
  .complete-time {
    padding: 0;
    @include fontColorOpacity(.8);
    border-radius: 2px;
    font-size: 14px;
  }
  .remind {
    border: 0 none;
    color: #ff8b23;
  }
  .expired {
    border: 0 none;
    color: #ff3939;
  }
  .complete {
    border: 0 none;
  }
}

.task-panel-right-more {
  .el-dropdown-menu__item {
    justify-content: flex-start;
  }
}

.task-box-more-dropdown {
  .task-box-more-del {
    margin-bottom: 8px;
    // color: #FF3939;
    // &:hover {
    //   color: #FF3939;
    //   background: rgba(255, 57, 57, .08);
    // }
    // &:active {
    //   color: #FF3939 !important;
    //   background: rgba(255, 57, 57, .16) !important;
    // }
    i {
      // color: #FF3939;
      margin-right: 10px;
    }
  }
}
</style>
